import { Component } from '@angular/core';

@Component({
  selector: 'app-block-temp',
  styles: [`
    :host {
      text-align: center;
    }
    .loader-pink div
{
    background-color: #e91e63 !important;
}

.loader-container div
{
  
}

.loader-pink.ball-clip-rotate div
{
    border-color: #e91e63 !important;
    border-bottom-color: transparent !important;
    background-color: transparent !important;
}

.loader-pink.ball-clip-rotate-pulse div:first-child
{
    background: #e91e63 !important;
}

.loader-pink.ball-clip-rotate-pulse div:last-child
{
    border-color: #e91e63 transparent #e91e63 transparent !important;
    background: transparent !important;
}

.loader-pink.ball-clip-rotate-multiple div
{
    border-color: transparent #e91e63 transparent #e91e63 !important;
    background-color: transparent !important;
}

.loader-pink.ball-rotate div:before,
.loader-pink.ball-rotate div:after
{
    background-color: #e91e63 !important;
}

.loader-pink.ball-triangle-path div
{
    border-color: #e91e63 !important;
    background-color: transparent !important;
}

.loader-pink.ball-scale-ripple div
{
    border-color: #e91e63 !important;
    background-color: transparent !important;
}

.loader-pink.ball-scale-ripple-multiple div
{
    border-color: #e91e63 !important;
    background-color: transparent !important;
}

.loader-pink.triangle-skew-spin div
{
    border-bottom-color: #e91e63 !important;
    background-color: transparent !important;
}

.loader-pink.semi-circle-spin div
{
    background-color: transparent !important;
    background-image: -webkit-gradient(linear, right top, right bottom, from(transparent), color-stop(70%, transparent), color-stop(30%, #e91e63), to(#e91e63));
    background-image: -webkit-linear-gradient(transparent 0%, transparent 70%, #e91e63 30%, #e91e63 100%);
    background-image:    -moz-linear-gradient(transparent 0%, transparent 70%, #e91e63 30%, #e91e63 100%);
    background-image:      -o-linear-gradient(transparent 0%, transparent 70%, #e91e63 30%, #e91e63 100%);
    background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(70%, transparent), color-stop(30%, #e91e63), to(#e91e63));
    background-image:         linear-gradient(transparent 0%, transparent 70%, #e91e63 30%, #e91e63 100%);
}

.loader-pink.fading-circle div
{
    background-color: transparent !important;
}
.loader-pink.fading-circle div:before
{
    background-color: #e91e63 !important;
}

.loader-pink.folding-cube div
{
    background-color: transparent !important;
}
.loader-pink.folding-cube div:before
{
    background-color: #e91e63 !important;
}

.color-message{
    color : #F8F8FF !important;
}



  `],
  template: `
    <div class="block-ui-template">
      <div class="loader-container">
        <div class="ball-grid-beat loader-pink">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <br><br><br><br><br>
      <div>
      <br><br>
      
      <strong><h5 class="color-message">{{message}}</h5></strong></div>
    </div>
  `
})
export class BlockTemplateComponent {
  message: any;
}
